import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  pn,
} from "@compass/core";
import { PieChart } from "devextreme-react";
import { Connector, Label, Series } from "devextreme-react/pie-chart";
import { AprEocTabH as AprResponseModel, AprEocTabHItem, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabH = (props: {
  data: AprResponseModel | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {

  const ncesField = (schoolRow: AprEocTabHItem) => {
    const propertyName = pn<AprEocTabHItem>("ncesId");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.ncesId}
      </DataDisplay>
    );
  };

  const schoolNameField = (schoolRow: AprEocTabHItem) => {
    const propertyName = pn<AprEocTabHItem>("targetSchoolName");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.targetSchoolName}
      </DataDisplay>
    );
  };

  const cityField = (schoolRow: AprEocTabHItem) => {
    const propertyName = pn<AprEocTabHItem>("city");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.city}
      </DataDisplay>
    );
  };

  const stateField = (schoolRow: AprEocTabHItem) => {
    const propertyName = pn<AprEocTabHItem>("state");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.state}
      </DataDisplay>
    );
  };

  const zipCodeField = (schoolRow: AprEocTabHItem) => {
    const propertyName = pn<AprEocTabHItem>("zipCode");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.zipCode}
      </DataDisplay>
    );
  };

  const numberServedField = (schoolRow: AprEocTabHItem) => {
    const propertyName = pn<AprEocTabHItem>("numberServed");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.numberServed}
      </DataDisplay>
    );
  };

  const dualEnrollmentField = (schoolRow: AprEocTabHItem) => {
    const propertyName = pn<AprEocTabHItem>("dualEnrolled");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.dualEnrolled}
      </DataDisplay>
    );
  };

  const renderSchoolRow = (schoolRow: AprEocTabHItem, index: number) => {
    return (
      <Grid item xs={12}>
        <Grid container spacing="md">
          <Grid item xs={2}>
            {ncesField(schoolRow)}
          </Grid>
          <Grid item xs={2}>
            {schoolNameField(schoolRow)}
          </Grid>
          <Grid item xs={2}>
            {cityField(schoolRow)}
          </Grid>
          <Grid item xs={1}>
            {stateField(schoolRow)}
          </Grid>
          <Grid item xs={1}>
            {zipCodeField(schoolRow)}
          </Grid>
          <Grid item xs={2}>
            {numberServedField(schoolRow)}
          </Grid>
          <Grid item xs={2}>
            {dualEnrollmentField(schoolRow)}
          </Grid>
        </Grid>
      </Grid>
    );
    }

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Target Schools</Typography>
        <Grid container spacing="lg">
          {props.data?.schoolRows?.map((q, index) => renderSchoolRow(q, index))}

          <GridBreak />

          <Grid item xs={6}>
            <PieChart id="pie-tab-m" dataSource={props.data?.chartValues} palette="Bright" title="Participants" width="100%">
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
